/* eslint-disable react/destructuring-assignment */
import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { NavigateNext, NavigateBefore } from '@material-ui/icons';
import { DocumentViewer } from 'react-documents';
import { useSelector, useDispatch } from 'react-redux';
import Axios from 'axios';
import { isLocal, hostName } from '../../../../constants/apiEnv';
import DisplayPDF from '../../../Trainings/Detail/components/DisplayPDF';
import styles from './training.module.scss';
import StartQuiz from '../../../Trainings/Quiz/StartQuiz';
import Loading from '../../../../components/loading';
import { saveUserData } from '../../redux/action';
import { getCountryRegion } from '../../../../utils/helpers';
import Button from '../../../../components/button/button';

const Training = (props) => {
  const url = hostName.slice(6);
  const actionDispatch = useDispatch();
  const { changeStepper, currentStepper, saveCertificate, navigateTo, reAttemptQuiz, translation, suportedLanguages,
  unSuportedLanguage, handleQuizAnswers, userTrainingDataAction, selectedCategory } = props;

  const [pdfPageNumber, setPdfPageNumber] = useState(null);
  const [totalPdfPages, settotalPdfPages] = useState(null);
  const [currentContentIndex, setCurrentContentIndex] = useState(0);
  const [toggleQuiz, settoggleQuiz]=useState(true);
  const [loader, setLoader] = useState(true);
  const [toggelNext, setToggelNext] = useState(false);
  const [trainingProgress, handleTrainingProgress] = useState({ currentRecord: '',
  recordNum: 0,
  lastContentDraft: 0,
  traningCount: 0,
  currentPdfRecord: '' });
  const [content, setContent] =useState('');
  const [tracking_record_id, setTrackingrecordId] =useState(false);
  const [isBackToggle, setIsBackToggle] =useState(false);
  const [retakeTrigger, setRetakeTrigger] = useState(0);

  const lmsData = useSelector(ele => (ele?.permitManagement?.userData?.lms));
  const categoryTraining = useSelector(ele => (ele?.permitManagement?.userData?.category_trainings));
  const enable_category_training = useSelector(ele => (ele?.permitManagement?.userData?.enable_category_training));
  const disableVideoScroll = useSelector(ele => (ele?.permitManagement?.userData?.disable_video_scroll));
  const permitManagementStore = useSelector(state => state?.permitManagement);
  const testTaken=permitManagementStore?.userData?.permit?.tracking_info?.trainingTaken;
  const permitStatus=permitManagementStore?.userData?.permit?.status;
  const tracking_progress = useSelector(state => state?.permitManagement?.userData?.permit?.tracking_info);
  let contentType = '';

  const publicUrl = isLocal ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://apis.${getCountryRegion(permitManagementStore?.airportSettings?.installationId)}${url}/public`;

  const trainingData = [];
  const [playing, setPlaying] = useState(false);
  const [temp, setTemp] = useState(false);
  const [duration, setDuration] = useState(0);
  const [playedSeconds, setPlayedSeconds] = useState(0);

  useEffect(() => {
    if (userTrainingDataAction?.success === true && userTrainingDataAction?.loading === false && tracking_progress) {
      if (tracking_progress?.last_pdf_num) {
        if (currentStepper === 'quiz') {
          setPdfPageNumber(tracking_progress?.last_pdf_num || 1);
        } else if (tracking_progress?.last_pdf_num < totalPdfPages) {
        setPdfPageNumber(tracking_progress?.last_pdf_num + 1);
        }
      } else if (!tracking_progress?.last_pdf_num) {
        setPdfPageNumber(1);
      }
    }
  }, [tracking_progress, userTrainingDataAction, totalPdfPages, currentStepper]);

  const handlePlayPause = () => {
    setPlaying(!playing);
  };
  const handleProgress = (state) => {
    setPlayedSeconds(state.playedSeconds);
    setDuration(state.loadedSeconds);
  };
  const formatTime = (seconds) => {
    const date = new Date(null);
    date.setSeconds(seconds);
    return date.toISOString().substr(11, 8);
  };
  let selectedLanguageTraining= [];
  if (unSuportedLanguage) {
    selectedLanguageTraining= enable_category_training ? categoryTraining?.english?.[selectedCategory] : lmsData?.English;
  }

  if (!unSuportedLanguage) {
    suportedLanguages.forEach((ele) => {
      if (ele.name===JSON.parse(localStorage.getItem('adpLanguage')).name) {
        const name=`${ele.name.slice(0, 1).toUpperCase()}${ele.name.slice(1)}`;
        if (enable_category_training === true) {
          const lang = `${ele.name.slice(0, 1).toLowerCase()}${ele.name.slice(1)}`;
          selectedLanguageTraining= categoryTraining?.[lang]?.[selectedCategory] ? categoryTraining?.[lang]?.[selectedCategory] : [];
        } else {
          selectedLanguageTraining= lmsData?.[name]? lmsData?.[name] : lmsData?.English;
        }
      }
    });
  }

  if (selectedLanguageTraining?.sections) {
    selectedLanguageTraining.sections.forEach((ele) => {
      ele.contents.forEach((el) => {
        if (el) trainingData.push({ ...el, additional_config: ele?.additional_config });
      });
      });
  }

  const handleGetAdpData = () => {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: permitManagementStore?.otp
    };
    Axios.get(`${publicUrl}/driver_permit/get_dp/${permitManagementStore?.airportSettings?.id}/
${permitManagementStore?.airportSettings?.airportCode?.toUpperCase()}`, { headers })
    .then(async (res) => {
      actionDispatch(saveUserData(res.data));
      setTemp(true);
    })
    .catch(() => {
      setTimeout(() => {
        setLoader(false);
        navigateTo('login', 'login');
        props.history.push(localStorage.getItem('pathname'));
        localStorage.removeItem('pathname');
      }, 2000);
    });
  };

  const handelSubmission = (data) => {
    setLoader(true);
    const headers = {
      'Content-Type': 'application/json',
      Authorization: permitManagementStore?.otp
    };
    let payload={ ...data };
    let apiUrl = permitStatus===8 ? 'update_suspended_dp' : 'update_dp';
    payload={ ...payload, lms: selectedLanguageTraining?.id };
    Axios.post(`${publicUrl}/driver_permit/${apiUrl}/${permitManagementStore?.airportSettings?.id}/
${permitManagementStore?.airportSettings?.airportCode?.toUpperCase()}`, { ...payload }, { headers })
      .then((res) => {
        const trackingInfo = payload.tracking_info || {};
        if (res?.data?.tracking_info) {
            if (trackingInfo?.testAttempts) {
                localStorage.setItem('testAttemps', trackingInfo.testAttempts);
            }
            if (currentStepper === 'training' || currentStepper === 'quiz') {
                setLoader(true);
                handleGetAdpData();
            }
        }
        if (res?.data?.certificate_url) {
          navigateTo('certificate', 'certificate');
          setLoader(false);
          saveCertificate(res?.data?.certificate_url);
        }
      })
      .catch(() => {
        setLoader(true);
        setTimeout(() => {
          setLoader(false);
          navigateTo('login', 'login');
          props.history.push(localStorage.getItem('pathname'));
          localStorage.removeItem('pathname');
        }, 2000);
      });
  };

  const handelPdfPages=(value) => {
    if (value) {
      if (totalPdfPages !== pdfPageNumber) setPdfPageNumber(pdfPageNumber + 1);
    } else if (pdfPageNumber > 0) setPdfPageNumber(pdfPageNumber - 1);
  };

  const handlePdfNextButton = (value) => {
    setPdfPageNumber(value?pdfPageNumber + 1: pdfPageNumber - 1);
    handleTrainingProgress({ ...trainingProgress, currentPdfRecord: value });
    setTrackingrecordId(value?.id);
  };

  const handleLoaderStop = () => {
    if (loader) {
      setTimeout(() => {
        setLoader(false);
      }, 5000);
    }
  };

  const handleLoaderStart = () => {
    if (temp) {
      setLoader(true);
      setTemp(false);
      handleLoaderStop();
    } else {
      handleLoaderStop();
    }
  };

  const getTraining = (index) => {
    handleLoaderStart();

    if (localStorage.getItem('currentIndex') && currentStepper==='training') {
      if (trainingData[0]?.url.includes('pdf')) {
        contentType = 'pdf';
        // setTimeout(() => {
        //   setToggelNext(true);
        // }, 30000);
        return (
          <DisplayPDF
            pdf={{
              id: 1,
              preview: trainingData[0]?.url,
              url: trainingData[0]?.url,
              file_name: trainingData[0]?.file_name
            }}
            handleNextPrev={(value) => { handelPdfPages(value); }}
            setNumPages={settotalPdfPages}
            pageNumberProps={pdfPageNumber}
            adp
            translation={translation}
          />
        );
      } if (trainingData[0]?.url.includes('ppt')) {
        contentType = 'ppt';
        setTimeout(() => {
          setLoader(false);
        }, 5000);
        return (
          <div style={{ width: '100%', height: '635px' }}>
            <DocumentViewer
              queryParams="hl=en"
              url={trainingData[index]?.url}
              overrideLocalhost="https://react-doc-viewer.firebaseapp.com/"
            />
          </div>
        );
      }
    } else if ((reAttemptQuiz || testTaken) && currentContentIndex !== false && toggleQuiz) {
      contentType = 'quiz';
      changeStepper('quiz');
      return (
        <StartQuiz
          key={retakeTrigger}
          retakeTrigger={retakeTrigger || tracking_progress?.quiz?.retake_fail_question}
          {...props}
          quizData={trainingData[trainingData.length - 1]}
          handleSaveContent={() => { ''; }}
          adp
          params={props}
          handelSubmission={handelSubmission}
          navigateToFailurePage={navigateTo}
          setCurrentContentIndex={setCurrentContentIndex}
          trainingData={trainingData}
          translation={translation}
          handleQuizAnswers={handleQuizAnswers}
          currentQuizz={tracking_progress}
        />
      );
    } if (trainingData[index]
      && (trainingData[index]?.content_type?.includes('pdf') || trainingData[index]?.file_name?.includes('pdf') || currentContentIndex === false)) {
      if (trainingData?.[0]?.content_type?.includes('mp4')) {
        contentType = 'mp4';
        if (content!=='mp4') {
          setContent('mp4');
        }
        return (
          <>
          <ReactPlayer
            url={trainingData[index]?.url}
            width="100%"
            height="80%"
            controls={disableVideoScroll === false}
            playsinline
            playing={playing}
            previewTabIndex
            onEnded={() => handleDraftTraining(trainingData[index], index)}
            style={{ borderRadius: '5px', margin: 'auto', marginTop: '3%' }}
            onProgress={disableVideoScroll !== false ? handleProgress : () => ({})}
          />
          {disableVideoScroll !== false && (
            <>
            <button onClick={handlePlayPause}>{playing ? 'Pause' : 'Play'}</button> &nbsp;
            <span>Time: {formatTime(playedSeconds)} / {formatTime(duration)}</span>
            </>
          )}
          </>
        );
      }

      contentType = 'pdf';
      // setTimeout(() => {
      //   setToggelNext(true);
      // }, 30000);
      return (
        <DisplayPDF
          pdf={{
            id: 1,
            preview: trainingData[index]?.url,
            url: trainingData[index]?.url,
            file_name: trainingData[index]?.file_name
          }}
          handleNextPrev={value => handlePdfNextButton(value)}
          setNumPages={settotalPdfPages}
          pageNumberProps={pdfPageNumber}
          adp
          translation={translation}
        />
      );
    } if (trainingData[index]?.content_type?.includes('ppt') || trainingData[index]?.file_name?.includes('ppt')) {
      contentType = 'ppt';
      setTimeout(() => {
        setLoader(false);
      }, 5000);
      // setTimeout(() => {
      //   setToggelNext(true);
      // }, 30000);
      return (
        <div style={{ width: '100%', height: '635px' }}>
          <DocumentViewer
            queryParams="hl=en"
            url={trainingData[index]?.url}
            overrideLocalhost="https://react-doc-viewer.firebaseapp.com/"
          />
        </div>
      );
    } if (trainingData?.[index] && (trainingData[index]?.content_type?.includes('mp4') || trainingData[index]?.file_name?.includes('mp4'))
    && (tracking_record_id ? Number(tracking_record_id) === Number(trainingData[index]?.id) : true)) {
      contentType = 'mp4';
      if (content!=='mp4') {
        setContent('mp4');
      }
      return (
        <>
        <ReactPlayer
            url={trainingData[index]?.url}
            width="100%"
            height="80%"
            controls={disableVideoScroll === false}
            playsinline
            playing={playing}
            previewTabIndex
            onEnded={() => handleDraftTraining(trainingData[index], index)}
            style={{ borderRadius: '5px', margin: 'auto', marginTop: '3%' }}
            onProgress={disableVideoScroll !== false ? handleProgress : () => ({})}
          />
          {disableVideoScroll !== false && (
            <>
            <button onClick={handlePlayPause}>{playing ? 'Pause' : 'Play'}</button> &nbsp;
            <span>Time: {formatTime(playedSeconds)} / {formatTime(duration)}</span>
            </>
          )}
        </>
      );
    } if (trainingData[index]?.pass_marks) {
      contentType = 'quiz';
      return (
        <StartQuiz
          key={retakeTrigger}
          retakeTrigger={retakeTrigger || tracking_progress?.quiz?.retake_fail_question}
          {...props}
          quizData={trainingData[index]}
          handleSaveContent={() => { ''; }}
          adp
          params={props}
          handelSubmission={handelSubmission}
          navigateToFailurePage={navigateTo}
          currentQuizz={tracking_progress}
        />
      );
    } if (trainingData[index]?.type === 'url') {
      return (
        <p>
          {/* <a href={trainingData[index]?.url}
            target="_blank"
            style={{ color: '#3A61A8', borderBottom: '1px solid #3A61A8' }}
          >
            Open Url In New Tab
          </a> */}
        </p>
      );
    }
    return null;
  };

  const handelNavigation = (navigate) => {
    if (navigate === 'next') {
      if (contentType === 'pdf') {
        handleTrainingProgress({ ...trainingProgress, currentPdfRecord: trainingData[currentContentIndex] });
        handleSaveDraftTraining(trainingData[currentContentIndex]);
        if (totalPdfPages === pdfPageNumber) {
          setCurrentContentIndex(currentContentIndex + 1);
          localStorage.removeItem('currentIndex');
        } else if (pdfPageNumber < totalPdfPages) setPdfPageNumber(pdfPageNumber + 1);
      } else {
        setIsBackToggle(true);
        if (currentContentIndex === trainingData.length - 1) {
          return null;
        } setCurrentContentIndex(currentContentIndex + 1);
          setTrackingrecordId(trainingData?.[currentContentIndex + 1]?.id);
      }
    } else if (contentType === 'pdf') {
      setCurrentContentIndex(0);
      //   if pdf is at in 0 index
      if (pdfPageNumber === 1 && currentContentIndex === 0) return null;
      //   if pdf is not in 0 index
      if (pdfPageNumber === 1) {
        setCurrentContentIndex(currentContentIndex - 1 > 0 ? currentContentIndex - 1 : 0);
        changeStepper('training');
      } else {
        handleTrainingProgress({ ...trainingProgress, lastContentDraft: pdfPageNumber });
        setPdfPageNumber(pdfPageNumber - 1 > 0 ? pdfPageNumber - 1 : 1);
      }
    } else {
      if (permitManagementStore?.userData?.permit?.tracking_info?.trainingTaken) {
        setCurrentContentIndex(false);
        settoggleQuiz(false);
        changeStepper('training');
      }
      if (currentContentIndex === 0) { return null; }
      handleTrainingProgress({ ...trainingProgress, lastContentDraft: currentContentIndex });
      let newCurrentIndex = currentContentIndex - 1 > 0 ? currentContentIndex - 1 : 0;
      setTrackingrecordId(trainingData[newCurrentIndex]?.id);
      setIsBackToggle(true);
      setCurrentContentIndex(newCurrentIndex);
      changeStepper('training');
    }
    setToggelNext(false);
    return null;
  };
  useEffect(() => {
    if (currentStepper !== 'quiz') {
      if (contentType === 'quiz') {
        changeStepper('quiz');
      }
    }
  }, [contentType, changeStepper, currentStepper]);

  const handleDraftTraining = (recordVal, recordNum) => {
    setToggelNext(true);
    setPlaying(false);
    setTrackingrecordId(recordVal?.id);
    handleTrainingProgress({ ...trainingProgress, currentRecord: recordVal, recordNum });
  };

  const handleSaveDraftTraining = (pdfRecord) => {
    if (trainingProgress?.currentRecord && trainingProgress?.lastContentDraft <= trainingProgress.recordNum) {
      const tracking_info = {
        last_content_id: trainingProgress?.currentRecord.id,
        last_index: trainingProgress.recordNum
      };
      localStorage.setItem('traningAttemps', tracking_info.training_count);
      handelSubmission({ tracking_info });
    }
    if (!trainingProgress?.currentRecord?.attachment_id && pdfPageNumber && trainingProgress?.lastContentDraft < pdfPageNumber) {
      const tracking_info = {
        last_pdf_num: pdfPageNumber,
        last_content_id: pdfRecord?.id
      };
      handelSubmission({ tracking_info });
    }
  };
  useEffect(() => {
    if (tracking_progress?.last_index && trainingProgress.recordNum === 0 && !isBackToggle) {
      setCurrentContentIndex(tracking_progress?.last_index + 1);
      if (trainingData?.[currentContentIndex]?.id === tracking_progress?.last_content_id) {
        setTrackingrecordId(tracking_progress?.last_content_id);
      } else {
        setTrackingrecordId(trainingData?.[currentContentIndex]?.id);
      }
    } else if (tracking_progress?.last_pdf_num && totalPdfPages) {
      if (totalPdfPages === tracking_progress?.last_pdf_num) {
        localStorage.removeItem('currentIndex');
      }
      if (Number(trainingData?.[currentContentIndex]?.id) === Number(tracking_progress?.last_content_id)) {
        setTrackingrecordId(tracking_progress?.last_content_id);
      } else {
        setTrackingrecordId(trainingData?.[currentContentIndex]?.id);
      }
    }
    if (!tracking_progress?.last_index && !trainingData[currentContentIndex]?.content_type?.includes('pdf')) {
      setTrackingrecordId(trainingData?.[currentContentIndex]?.id);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tracking_progress, totalPdfPages, currentContentIndex, trainingProgress.recordNum, trainingData]);

  const checkRecheckQuizz = () => {
    const contentQuiz = trainingData.find(q => q.id === tracking_progress?.quiz?.form_id);
    if (contentQuiz?.additional_config?.whenQuizFail === 'Re-attempts quiz for wrong answers only'
      && Number(tracking_progress?.quiz?.total_reattempts) > Number(tracking_progress?.testAttempts)
      && Number(tracking_progress?.quiz?.obtained_marks) < Number(tracking_progress?.quiz?.pass_marks)) {
      if (tracking_progress?.quiz?.retake_fail_question) {
        return false;
      }
      return true;
    }
    if (contentQuiz?.additional_config?.whenQuizFail === 'Re-attempts quiz for wrong answers only'
      && contentQuiz?.additional_config?.whenReattemptFail === 'Mandatory Wait Time until Reattempt'
      && Number(tracking_progress?.quiz?.obtained_marks) < Number(tracking_progress?.quiz?.pass_marks)
      && Number(tracking_progress?.testAttempts) === Number(tracking_progress?.quiz?.total_reattempts)
      && (new Date().getTime() - new Date(tracking_progress?.quiz?.attempt_date).getTime()) / (1000 * 60 * 60 * 24)
      > Number(contentQuiz?.additional_config?.no_of_days_to_mandate_for_reattempts_failure)) {
      return true;
    }
    return false;
  };

  const getFailedQuestionIds = (quizDraft, fields) => {
    const failed = [];

    Object.keys(quizDraft).forEach((qid) => {
      const field = fields.find(f => f.id === qid);
      if (!field) return;

      const selected = quizDraft[qid] || [];

      const correctAnswers = field.values
        .filter(v => v.correct_answer)
        .map(v => v.value.toLowerCase());

      const selectedNormalized = selected.map(a => a.toLowerCase());

      const isCorrect = correctAnswers.length === selectedNormalized.length
        && correctAnswers
          .sort()
          .every((val, i) => val === selectedNormalized.sort()[i]);

      if (!isCorrect) {
        failed.push(qid);
      }
    });

    return failed;
  };

  const getCorrectQuizDraft = (quizDraft, fields) => {
    const result = {};

    Object.keys(quizDraft).forEach((qid) => {
      const field = fields.find(f => f.id === qid);
      if (!field) return;

      const selected = quizDraft[qid] || [];

      const correctAnswers = field.values
        .filter(v => v.correct_answer)
        .map(v => v.value.toLowerCase());

      const selectedNormalized = selected.map(a => a.toLowerCase());

      const isCorrect = correctAnswers.length === selectedNormalized.length
        && correctAnswers
          .slice()
          .sort()
          .every((val, i) => val === selectedNormalized.slice().sort()[i]);

      if (isCorrect) {
        result[qid] = quizDraft[qid];
      }
    });

    return result;
  };

  const retakeTraining = () => {
    const contentQuiz = trainingData.find(q => q.id === tracking_progress?.quiz?.form_id);
    const quiz = selectedLanguageTraining?.sections.find(item => item.quiz.id === tracking_progress?.quiz?.form_id)?.quiz;
    let data = tracking_progress;
    let updated_attempt = tracking_progress?.quiz;

    const failedIds = getFailedQuestionIds(
      updated_attempt?.response,
      quiz?.schema.fields
    );

    const correctAnswers = getCorrectQuizDraft(
      updated_attempt?.response,
      quiz?.schema.fields
    );

    const newAttempt = {
      ...updated_attempt,
      attempt_date: new Date(),
      current_attempt_result: '',
      retake_fail_question:
        contentQuiz?.additional_config?.whenQuizFail === 'Re-attempts quiz for wrong answers only',
      failedQuestionIds:
        contentQuiz?.additional_config?.whenQuizFail === 'Re-attempts quiz for wrong answers only'
          ? failedIds
          : [],
      response: correctAnswers,
      need_to_reattempt: false,
      final_result: ''
    };
    data.testAttempts = (Number(tracking_progress?.testAttempts) === Number(updated_attempt?.total_reattempts)
      && contentQuiz?.additional_config?.whenQuizFail === 'Re-attempts quiz for wrong answers only'
    && contentQuiz?.additional_config?.whenReattemptFail === 'Mandatory Wait Time until Reattempt')
      ? 0 : (Number(tracking_progress?.testAttempts) || 0);
    data.quiz = newAttempt;
    localStorage.setItem('testAttemps', data.testAttempts);
    if (contentQuiz?.additional_config?.whenQuizFail === 'Re-attempts quiz for wrong answers only') {
      setRetakeTrigger(prev => prev + 1);
    }
    handelSubmission({ tracking_info: data, quiz: { ...data.quiz } });
  };


  return (
    <>
      <div className={styles.trainingContainer1} style={{ width: '53%' }}>
        <Loading loadingStatus={loader} />
        {/* <div className={styles.trainingContainer1}> */}
        {!reAttemptQuiz && (
          <div role="button" tabIndex={0} className={styles.navigatePrevious} onClick={() => { handelNavigation('previous'); }}
          onKeyPress={() => { handelNavigation('previous'); }}>
            <NavigateBefore style={{ fontSize: '55px' }} />
          </div>
        )}
        {currentStepper !== 'quiz' && toggelNext && content==='mp4' && (
          <div role="button" tabIndex={0} className={styles.navigateNext} onClick={() => { handelNavigation('next'); handleSaveDraftTraining(); }}
          onKeyPress={() => { handelNavigation('next'); handleSaveDraftTraining(); }}>
            <NavigateNext style={{ fontSize: '55px' }} />
          </div>
        )}
        {currentStepper !== 'quiz' && content!=='mp4' && (
          <div role="button" tabIndex={0} className={styles.navigateNext} onClick={() => { handelNavigation('next'); }}
          onKeyPress={() => { handelNavigation('next'); }}>
            <NavigateNext style={{ fontSize: '55px' }} />
          </div>
        )}
        {getTraining(currentContentIndex || 0)}
        {checkRecheckQuizz()
          && <Button
            onClick={() => { retakeTraining(); }}
            translationID="lms.add.quiz.finish1"
            defaultText="Retake"
            className={styles.retakeButton}
          />
        }
        {/* </div> */}
      </div>
      <div className={styles.trainingContainer2}>
        <Loading loadingStatus={loader} />
        {/* <div className={styles.trainingContainer2}> */}
        <div className={styles.mobileNavigation}>
          {!reAttemptQuiz && (
            <div role="button" tabIndex={0} onClick={() => { handelNavigation('previous'); }}
            onKeyPress={() => { handelNavigation('previous'); }}>
              <NavigateBefore style={{ fontSize: '55px', color: 'rgb(50,51,102)' }} />
            </div>
          )}
          {currentStepper !== 'quiz' && toggelNext && content==='mp4' && (
            <div role="button" tabIndex={0} onClick={() => { handelNavigation('next'); handleSaveDraftTraining(); }}
            onKeyPress={() => { handelNavigation('next'); handleSaveDraftTraining(); }}>
              <NavigateNext style={{ fontSize: '55px', color: 'rgb(50,51,102)' }} />
            </div>
          )}
          {currentStepper !== 'quiz' && content!=='mp4' && (
            <div role="button" tabIndex={0} onClick={() => { handelNavigation('next'); }}
            onKeyPress={() => { handelNavigation('next'); }}>
              <NavigateNext style={{ fontSize: '55px', color: 'rgb(50,51,102)' }} />
            </div>
          )}
        </div>
        {getTraining(currentContentIndex || 0)}
        {/* </div> */}
      </div>
    </>
  );
};
export default Training;
